export default "__VITE_ASSET__gcr9$nZQ__"